var _path, _path2;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconPlusCircle = function SvgIconPlusCircle(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 23.438,
    viewBox: "0 0 23.438 23.438",
    width: 23.438,
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m11.719 0a11.719 11.719 0 1 1 -11.719 11.719 11.719 11.719 0 0 1 11.719-11.719z",
    fill: "#56af56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m4.1 9.375v-4.1h-4.1v-1.175h4.1v-4.1h1.173v4.1h4.1v1.173h-4.1v4.1z",
    fill: "#fff",
    transform: "translate(7.031 7.031)"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconPlusCircle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-plus-circle.0c982892.svg";
export { ForwardRef as ReactComponent };